import { render, staticRenderFns } from "./AlternateLoginCard.vue?vue&type=template&id=7d0036d5"
import script from "./AlternateLoginCard.vue?vue&type=script&lang=ts"
export * from "./AlternateLoginCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports